import { Vue, Component, Prop } from 'vue-property-decorator'
import ProductMenuItem from '~/types/ProductMenuItem'

@Component
export default class ProductMenu extends Vue {
  @Prop({ required: true, type: Array })
  readonly items!: ProductMenuItem[]

  scrollTo (item: ProductMenuItem) {
    const elem = document.querySelector(item.selector)
    if (elem) {
      const offset = window.scrollY + elem.getBoundingClientRect().top - window.innerHeight / 4
      window.scroll({ top: offset, left: 0, behavior: 'smooth' })
    }
  }

  render () {
    return (
      <div class="product-page-menu">
        <div class="product-page-menu__row">
          <div class="product-page-menu__col-line">
            <div class="product-page-menu__line"></div>
          </div>
          <div class="product-page-menu__col-items">
            {this.items.map(e => (
              <div key={e.code} onClick={() => this.scrollTo(e)} class="product-page-menu__item">
                {e.code === 'instruction' ? <h2>{e.name}</h2> : e.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}
